import React from 'react';
import { ComposableModal, ModalContent, ModalFooter } from '#app/components/ModalForm';
import { Button } from 'finform';
import RoboadvisorSubscribe from '#app/pages/Auth/RoboadvisorSubscribe';

const SubscribeModal = ({ show, handleCloseModal, handleSubscribeModal, i18n }) => (
  <ComposableModal
    size="extra-small"
    show={show}
    trigger=""
    title="Уведомить о запуске Robo-advisor"
    titleStyle={{ width: '100%', lineHeight: '28px', textAlign: 'center' }}
    onClose={handleCloseModal}
    closeButtonVariant="landing"
  >
    <ModalContent>
      <RoboadvisorSubscribe callback={handleSubscribeModal} />
    </ModalContent>
    <ModalFooter>
      <Button flex style={{ margin: '5px' }} className="style1" onClick={handleCloseModal}>
        {i18n.auth?.cancel}
      </Button>
    </ModalFooter>
  </ComposableModal>
);

export default SubscribeModal;

/*
// ——— Классовый компонент (сохранён для справки, для поиска ошибок) ———
import React, { Component } from 'react';
import { ComposableModal, ModalContent, ModalFooter } from '#app/components/ModalForm';
import { Button } from 'finform';
import RoboadvisorSubscribe from '#app/pages/Auth/RoboadvisorSubscribe';

class SubscribeModalClass extends Component {
  render() {
    const { show, handleCloseModal, handleSubscribeModal, i18n } = this.props;
    return (
      <ComposableModal
        size="extra-small"
        show={show}
        trigger=""
        title="Уведомить о запуске Robo-advisor"
        titleStyle={{ width: '100%', lineHeight: '28px', textAlign: 'center' }}
        onClose={handleCloseModal}
        closeButtonVariant="landing"
      >
        <ModalContent>
          <RoboadvisorSubscribe callback={handleSubscribeModal} />
        </ModalContent>
        <ModalFooter>
          <Button flex style={{ margin: '5px' }} className="style1" onClick={handleCloseModal}>
            {i18n.auth?.cancel}
          </Button>
        </ModalFooter>
      </ComposableModal>
    );
  }
}

export default SubscribeModalClass;
*/
